export const MOCK_MESSAGE_A_ID = 'MOCK_MESSAGE_A_ID'
